import { gql } from "@apollo/client";

// A signal that the signed-in user's session changed — their account, their
// permission profile, or (with logout) their password. It carries no user
// data: SessionProvider reacts by refetching the session from the API.
//
// It used to carry the whole user document, password hash included, and the
// browser wrote it into its own token — which is why the browser needed the
// token signing key.
export const USER_PERMISSIONS_SUB = gql`
  subscription userPermissionsSubs {
    userPermissionsSubs {
      logout
      userId
      permissionId
    }
  }
`;
